"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var checkboxTheme = function (theme) { return ({
    width: '1rem',
    height: '1rem',
    shadow: '0 1px 0 0 rgba(22, 29, 37, 0.05)',
    borderWidth: '.0625rem',
    //  borderColor: '#4e5051',
    borderColor: theme.greyDark.color.normal,
    backgroundColor: '#fff',
    error: {
        borderColor: theme.error.color.normal,
        backgroundColor: theme.base.color.normal,
    },
    checkMark: {
        top: '.125rem',
        left: '.25rem',
        width: '.1875rem',
        height: '.4375rem',
        borderWidth: '.125rem',
        color: theme.base.color.text,
        error: {
            color: theme.error.color.normal,
        },
        disabled: {
            // color: '#b1b4b7',
            color: theme.greyNormal.color.normal,
        },
    },
    focus: {
        borderWidth: '.125rem',
        //    borderColor: '#262729',
        borderColor: theme.global.color.textDark,
    },
    checked: {
        //    borderColor: '#262729',
        borderColor: theme.global.color.textDark,
    },
    disabled: {
        //    backgroundColor: '#eef3f7',
        backgroundColor: theme.greyLight.color.normal,
        //    borderColor: '#b1b4b7',
        borderColor: theme.greyNormal.color.normal,
    },
}); };
exports.default = checkboxTheme;
//# sourceMappingURL=theme.js.map